import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  const heroStyle = {
    background: `linear-gradient(rgba(26, 54, 93, 0.75), rgba(15, 39, 68, 0.85)), url(${process.env.PUBLIC_URL}/TeamImage.JPG)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <section id="home" className="hero" style={heroStyle}>
      <div className="hero-content-wrapper">
        <div className="hero-content">
          <h1>Expert Clinical Exercise Physiology</h1>
          <p>Bespoke exercise physiology programmes for partners, CEOs, and corporate leaders.
            Serving London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex. Clinical expertise in MSK, oncology, and complex conditions.</p>
          <Link to="/contact" className="cta-button">Book a Consultation</Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
